export const extensionId = "ue-extension";
